module.exports = __webpack_public_path__ + "img/user_card_empty.e2de822c.png";